import { Stack, TextField, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';
import { formatDate } from 'v2/utils/dateTime';

interface Props {
  cardUuid: string;
  blockedSince: string;
  blockedReason: string | null;
}

const BlockedAccessCardModal: React.FC<Props> = ({ cardUuid, blockedSince, blockedReason }) => {
  const { translation } = useTranslation();

  const sentence = translation.card_was_blocked_on_template
    .replace('{uuid}', cardUuid)
    .replace('{datetime}', formatDate(blockedSince, 'dateTime'));

  return (
    <ModalTemplate
      title={translation.card_blocked}
      secondaryAction={{ label: translation.close, id: 'blocked-access-card-close-button' }}
    >
      <Stack gap={3}>
        <Typography variant="body2">{sentence}</Typography>
        {blockedReason && (
          <TextField label={translation.description} value={blockedReason} multiline minRows={2} fullWidth disabled />
        )}
      </Stack>
    </ModalTemplate>
  );
};

export default BlockedAccessCardModal;
